import { RootStoreType } from './RootStore';
import { ApplicationStore } from './ApplicationStore';
import { flow, getRoot, Instance, types, detach } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { BlackPoint } from './models/BlackPoint';
import { Page } from '../common/enums';

export const BlackPointSearchCriteria = types.model({
  pharmacyId: types.maybeNull(types.number),
  treated: types.maybeNull(types.boolean),
  date: types.maybeNull(types.Date),
});

export const BlackPointStore = types
  .compose(
    getBaseStore<Instance<typeof BlackPoint>, Instance<typeof BlackPoint>>(BlackPoint, 'blackPointId', 'blackPoint'),
    types.model('BlackPointStore', {}),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          blackPointId: 0,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);
    const apiFetcher = env.api;

    const saveBlackPoint = flow(function*(blackPoint: Instance<typeof BlackPoint>) {
      const res = yield self.saveElement(blackPoint);
      // @ts-ignore
      if (blackPoint.blackPointId !== res.blackPointId) {
        // @ts-ignore
        (root.ApplicationStore as typeof ApplicationStore.Type).navigate(`${Page.BlackPoints}/${res.blackPointId}`);
      }
    });

    const updateBlackPointInStore = (blackPoint: Instance<typeof BlackPoint>) => {
      const blackPointModel = BlackPoint.create(blackPoint);
      self.datas.put(blackPointModel);
      return blackPointModel;
    };

    const search = flow(function*(criteria: Instance<typeof BlackPointSearchCriteria>) {
      const result = yield apiFetcher.get('blackpoint', {
        params: criteria,
      });
      self.datas.forEach((val) => detach(val));
      const resultBlackPoint: Array<Instance<typeof BlackPoint>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdBlackPoint = updateBlackPointInStore(node);
        resultBlackPoint.push(createdBlackPoint);
      });
      return resultBlackPoint;
    });

    return { search, saveBlackPoint };
  });

export type BlackPointStoreType = Instance<typeof BlackPointStore>;
